import axios from 'axios';
import { Message } from 'element-ui';
import store from '@/store';
var CryptoJS = require('crypto-js');
import router from '@/router/index';
let host = '';
if (window.location.host === 'saas-report.sscanmou.com' || window.location.host === 'map.sscanmou.com') {
    //生产环境
    host = 'https://saas-report.sscanmou.com/apiV2';
} else if (window.location.host === 'saas-report-test.sscanmou.com') {
    //测试环境
    host = 'https://api-saas-test.sscanmou.com';
} else {
    //这里需要本地代理才能访问
    // host = '/dev'; //开发环境
    // host = '/test'; //测试环境
    host = '/product'; //生产环境
}

/**
 * 当前接口请求环境（与上方 host 切换保持一致）
 * product | test | dev
 * 内嵌页地址请用 @/utils/embedEnv 跟随此环境
 */
export function getApiRequestEnv() {
    const pageHost = window.location.host;
    if (pageHost === 'saas-report.sscanmou.com' || pageHost === 'map.sscanmou.com') return 'product';
    if (pageHost === 'saas-report-test.sscanmou.com') return 'test';
    const h = String(host || '');
    if (h === '/product' || h.startsWith('/product/') || h.includes('saas-report.sscanmou.com')) return 'product';
    if (h === '/test' || h.startsWith('/test/') || h.includes('api-saas-test')) return 'test';
    if (h === '/dev' || h.startsWith('/dev/')) return 'dev';
    return 'test';
}

// 创建实例
axios.defaults.isSetAuth = false; // 是否设置授权信息
const Axios = axios.create({
    baseURL: host,
    timeout: 120000, // 请求超时时间ms
    retry: 5, // 请求重试次数
    retryDelay: 1000, // 请求重试间隔ms
    headers: {}
});
// 请求拦截
Axios.interceptors.request.use(
    (request) => {
        request.headers.Authorization = store.state.user.access_token;
        return request;
    },
    (error) => {
        Message.error('服务器开小差了，请稍后刷新或联系项目经理进行反馈。');
        return Promise.reject(error);
    }
);

// 响应拦截
Axios.interceptors.response.use(
    async (response) => {
        // 如果信息加密或者是字符串，则先解密或者反序列化为对象
        if (typeof response.data === 'string') {
            if (response.data.length > 0) {
                if (response.data[0] === '{') {
                    const output = JSON.parse(response.data);
                    response.data = output;
                } else {
                    // 新增AES解密
                    const key = CryptoJS.enc.Utf8.parse('f8db034bda44rtkb');
                    const bytes = CryptoJS.AES.decrypt(response.data, key, {
                        mode: CryptoJS.mode.ECB,
                        padding: CryptoJS.pad.Pkcs7
                    });
                    const outputStr = bytes.toString(CryptoJS.enc.Utf8);
                    const output = JSON.parse(outputStr);
                    response.data = output;
                }
            }
        }
        const okStatus = response.data.code == 0 || response.data.code == 200;
        const code = response.data.code;
        if (okStatus) {
            // 请求成功
            return Promise.resolve(response);
        } else {
            // 请求失败
            if (code === 401) {
                // 未登录或登录超时
                Message.error('登录失效，请重新登录！');
                if (window.location.host === 'saas-report.sscanmou.com') {
                    //生产环境
                    if (window.self !== window.top) {
                        window.location = 'https://saas.sscanmou.com/login';
                    } else {
                        if (store.state.user.merchantId == '2082') {
                            router.push('/password-login');
                        } else {
                            router.push('/login');
                        }
                    }
                } else if (window.location.host === 'map.sscanmou.com') {
                    //扫码登录生产环境
                    if (window.self !== window.top) {
                        window.location = 'https://map.sscanmou.com/#/login';
                    } else {
                        if (store.state.user.merchantId == '2082') {
                            router.push('/password-login');
                        } else {
                            router.push('/login');
                        }
                    }
                } else if (window.location.host === 'saas-report-test.sscanmou.com') {
                    //测试环境
                    if (window.self !== window.top) {
                        window.location = 'https://saas-test.sscanmou.com/login';
                    } else {
                        if (store.state.user.merchantId == '2082') {
                            router.push('/password-login');
                        } else {
                            router.push('/login');
                        }
                    }
                } else {
                    if (window.self !== window.top) {
                        window.location = 'http://10.1.1.159:9040/login';
                    } else {
                        if (store.state.user.merchantId == '2082') {
                            router.push('/password-login');
                        } else {
                            router.push('/login');
                        }
                    }
                }
                return Promise.reject(response);
            } else {
                // 其他请求失败情况
                Message.error(response.data.msg);
                return Promise.reject(response);
            }
        }
    },
    (error) => {
        Message.error('服务器开小差了，请稍后刷新或联系项目经理进行反馈。');
        return Promise.reject(error);
    }
);

export default Axios;
